import * as React from 'react';

import user from 'js/lib/user';

import { CourseraMetatags } from 'bundles/seo';
import DescriptionPageProjectPageSchemaMarkup from 'bundles/seo/components/DescriptionPageProjectPageSchemaMarkup';
import type { ConsumerCoursePageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/ConsumerCoursePageQuery';
import type { EnterpriseCoursePageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/EnterpriseCoursePageQuery';
import type { DomainFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/SharedCommonEntitiesFragments';

import _t from 'i18n!nls/xdp';

const getTotalContentHours = (ms?: number) => {
  if (!ms) {
    return 0;
  } else {
    return Math.floor(ms / 3600000);
  }
};

type Props = {
  pageData: ConsumerCoursePageFieldsFragment | EnterpriseCoursePageFieldsFragment;
  disableCrawlerIndexing?: boolean;
};

const ProjectPageSEO = ({ disableCrawlerIndexing, pageData }: Props) => {
  const { slug, description, ratings, name, primaryLanguages, partners, domains, metaImgSrc, material, instructors } =
    pageData;

  const domain: DomainFragment | undefined = domains?.[0];
  const metaDescription = _t(`Complete this Guided Project in under 2 hours. #{description}`, {
    description,
  });

  return (
    <>
      {!user.isAuthenticatedUser() && (
        <DescriptionPageProjectPageSchemaMarkup
          domain={domain}
          slug={slug}
          name={name}
          description={description}
          partners={partners}
          primaryLanguages={primaryLanguages}
          // @ts-expect-error Duration: string
          timeRequired={getTotalContentHours(material?.totalDuration)}
          ratings={ratings}
          instructors={instructors}
        />
      )}
      <CourseraMetatags
        metaNameAndProperties={{
          title: name,
          description: metaDescription,
          // @ts-expect-error URL: string
          absoluteImageHref: metaImgSrc,
          disableCourseraDescriptionSuffix: true,
          disableCourseraSuffix: true,
          descriptionLengthLimit: 160,
          disableCrawlerIndexing,
        }}
        {...(disableCrawlerIndexing && { hrefLangOverrides: () => [] })}
      />
    </>
  );
};

export default ProjectPageSEO;
